module.exports = __webpack_public_path__ + "img/BBF_example_en.87f1e216.png";